module.exports = __webpack_public_path__ + "static/media/MarkPro.3ae3b8d4.woff2";